// 首页
import request from '@/utils/request'

// 列表
export function getProblemPage(params) {
  return request({
    url: '/v3/manager/productProblemTracking/page',
    method: 'post',
    data: params
  })
}
// 保存
export function saveProblem(params) {
  return request({
    url: '/v3/manager/productProblemTracking/save',
    method: 'post',
    data: params
  })
}

// 修改状态
export function updateStatus(params) {
  return request({
    url: '/v3/manager/productProblemTracking/updateStatus',
    method: 'post',
    data: params
  })
}

// 根据Id获取问题
export function getById(id) {
  return request({
    url: '/v3/manager/productProblemTracking/getById/' + id,
    method: 'get'
  })
}

// 获取充电器信息
export function getChargerData(sn) {
  return request({
    url: '/v3/manager/charger/getChargerData?sn=' + sn,
    method: 'get'
  })
}

export function configList(sn) {
  return request({
    url: '/v3/manager/productProblemTracking/configList',
    method: 'get'
  })
}
// 上传文件
export function uploadImg(params) {
  console.log('uploadImg:params', params)
  var formData = new FormData()
  formData.append('multipartFile', params.raw)
  return request({
    url: '/v3/manager/commUpload/upload/' + params.childDir,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: formData
  })
}
// 上传文件--压缩
export function uploadImgAndCompression(params) {
  console.log('uploadImg:params', params)
  var formData = new FormData()
  formData.append('multipartFile', params.raw)
  return request({
    url: '/v3/manager/commUpload/uploadImgAndCompression/' + params.childDir,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: formData
  })
}
